import React from 'react';
import { useLocation } from 'react-router-dom';
import TemplateForm from 'Components/TemplateForm';
import { DocumentStatuses, DocumentTypes } from 'Interfaces/Document';

function TemplateCreate() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const activationStatus = searchParams.get('status') as DocumentStatuses | null;
  const isApiTemplate = activationStatus === DocumentStatuses.API;

  return (
    <TemplateForm
      initialValues={{
        type: DocumentTypes.TEMPLATE,
        status: DocumentStatuses.DRAFT,
        signers: [{ isPreparer: true, order: -1, role: 'Me (Now)' }, { order: 1 }],
        isApiTemplate,
      }}
    />
  );
}

export default TemplateCreate;
